module.exports = __webpack_public_path__ + "static/media/greenCircle.7830fc4d.svg";